import { useState } from "react";
import { GALLERY } from "@/lib/site";
import { X } from "@phosphor-icons/react";
import Reveal from "@/components/Reveal";
import useDocumentMeta from "@/hooks/useDocumentMeta";

export default function GalleryPage() {
  useDocumentMeta();
  const [active, setActive] = useState(null);

  const gridPattern = [
    "md:col-span-7 md:row-span-2 aspect-[4/5] md:aspect-auto",
    "md:col-span-5 aspect-[4/3]",
    "md:col-span-5 aspect-[4/3]",
    "md:col-span-4 aspect-square",
    "md:col-span-4 aspect-square",
    "md:col-span-4 aspect-square",
    "md:col-span-7 aspect-[4/3]",
    "md:col-span-5 aspect-[4/3]",
  ];

  return (
    <>
      <section className="max-w-7xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-12" data-testid="gallery-hero">
        <div className="overline">Gallery</div>
        <h1 className="font-serif text-5xl sm:text-6xl md:text-7xl tracking-tight leading-[0.95] mt-4 max-w-4xl">
          Caravan park Ballarat <em className="italic font-light">— mornings, evenings, and the bits between.</em>
        </h1>
        <p className="mt-6 text-sa-ink2 text-lg max-w-2xl leading-relaxed">
          Real photos from across our family-friendly Ballarat caravan park — the cabins, the powered sites, the camping pitches, and the bushland that surrounds them.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-32" data-testid="gallery-grid">
        <div className="grid grid-cols-1 md:grid-cols-12 auto-rows-[280px] gap-4">
          {GALLERY.map((g, i) => (
            <Reveal key={g.src} delay={(i % 4) * 60} className={`${gridPattern[i % gridPattern.length]} group`}>
              <button
                onClick={() => setActive(g)}
                className="relative w-full h-full overflow-hidden rounded-2xl bg-sa-bg2"
                data-testid={`gallery-img-${i}`}
              >
                <img
                  src={g.src}
                  alt={g.alt}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                  loading="lazy"
                />
              </button>
            </Reveal>
          ))}
        </div>
      </section>

      {active && (
        <div
          className="fixed inset-0 z-[60] bg-sa-ink/95 backdrop-blur-sm flex items-center justify-center p-6"
          onClick={() => setActive(null)}
          data-testid="lightbox"
        >
          <button className="absolute top-6 right-6 w-12 h-12 rounded-full bg-sa-bg/10 text-sa-bg grid place-items-center hover:bg-sa-bg/20" data-testid="lightbox-close">
            <X size={20} weight="bold" />
          </button>
          <img src={active.src} alt={active.alt} className="max-h-[88vh] max-w-[92vw] object-contain rounded-2xl" />
        </div>
      )}
    </>
  );
}
